import { DateOrdered } from './DateOrdered'
import { OrderStatus } from './OrderStatus'
import { TransactionStatus } from './TransactionStatus'

export const Filter = () => {
  return (
    <div className="dFlex flexWrap" style={{ gap: '12px 130px' }}>
      <OrderStatus />
      <TransactionStatus />
      <DateOrdered />
    </div>
  )
}
